import {
    StyledDecisionSupport,
    StyledEdit,
} from '@/components/decisionSupport/DecisionSupport.styled';
import { ClinicianRecommendationFragment } from '@/components/decisionSupport/queries/clinicianRecommendations.gql.types';
import { DecisionSupportSelection } from '@/components/decisionSupport/utils/decisionSupport.utils';
import { DialogType, useDialog } from '@/dialogs/DialogManager';
import { IconButton } from '@mui/material';
import { FC, useCallback } from 'react';

type LegacyClinicianDecisionSupportProps = {
    selectedClinician: DecisionSupportSelection | null;
    setSelectedClinician(selection: DecisionSupportSelection | null): void;
    recommendations: ClinicianRecommendationFragment[];
    disabled?: boolean;
};

export const LegacyClinicianDecisionSupport: FC<LegacyClinicianDecisionSupportProps> = (props) => {
    const { selectedClinician, setSelectedClinician, recommendations, disabled } = props;
    const { openDialog } = useDialog();

    const onClickEdit = useCallback(() => {
        openDialog(DialogType.LegacyClinicianDecisionSupport, {
            selectedClinician,
            setSelectedClinician,
            recommendations,
        });
    }, [openDialog, recommendations, selectedClinician, setSelectedClinician]);

    if (recommendations.length === 0) {
        return null;
    }

    return (
        <StyledDecisionSupport>
            <IconButton
                onClick={onClickEdit}
                disabled={disabled}
                aria-label='Edit clinician selection'
            >
                <StyledEdit />
            </IconButton>
        </StyledDecisionSupport>
    );
};
